export enum Breakpoint {
  XS = 0,
  S = 768,
  M = 1024,
  L = 1280,
  XL = 1440,
  XXL = 1920,
}
